import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import { transformAddress } from 'helpers/utils';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import { User } from './studentTable.type';
import Badge from 'components/base/Badge';
import FeatherIcon from 'feather-icons-react';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdown from './cell/ActionDropdown/ActionDropdown';

export const studentsTablecolumns: ColumnDef<User>[] = [
  {
    id: 'registerNumber',
    header: 'Register Number',
    accessorKey: 'info.registerNumber',
    cell: ({ row: { original } }) => {
      const { info } = original;
      return info?.registerNumber ?? '-';
    },
    meta: {
      headerProps: { style: { width: 70 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'username',
    header: 'Student Name',
    accessorKey: 'username',
    cell: ({ row: { original } }) => {
      const { username } = original;
      return username ?? '-';
    },
    meta: {
      headerProps: { style: { width: 70 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'email',
    header: 'Email Address',
    accessorKey: 'email',
    cell: ({ row: { original } }) => {
      const { email } = original;
      return email ?? '-';
    },
    meta: {
      headerProps: { style: { width: 70 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'gender',
    header: 'Gender',
    accessorKey: 'info.gender',
    cell: ({ row: { original } }) => {
      const {
        info: { gender }
      } = original;
      return gender ?? '-';
    },
    meta: {
      headerProps: { style: { width: 70 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'contactNumber',
    header: 'Contact Number',
    accessorKey: 'info.contactNumber',
    cell: ({ row: { original } }) => {
      const {
        info: { contactNumber }
      } = original;
      return contactNumber ?? '-';
    },
    meta: {
      headerProps: { style: { width: 70 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'address',
    header: 'Address',
    accessorKey: 'info.address',
    cell: ({ row: { original } }) => {
      const {
        info: { address }
      } = original;
      return transformAddress(address) ?? '-';
    },
    meta: {
      headerProps: { style: { width: 70 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'isVerified',
    header: 'Status',
    accessorKey: 'isVerified',
    cell: ({ row: { original } }) => {
      const { isVerified } = original;
      return (
        <Badge
          bg={isVerified ? 'success' : 'warning'}
          variant="phoenix"
          iconPosition="end"
          className="fs-10"
          icon={
            <FeatherIcon
              icon={isVerified ? 'check' : 'clock'}
              size={12.8}
              className="ms-1"
            />
          }
        >
          {isVerified ? 'Verified' : 'Not Verified'}
        </Badge>
      );
    },
    meta: {
      headerProps: { style: { width: 70 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'action',
    cell: ({ row: { original } }) => (
      <RevealDropdownTrigger>
        <RevealDropdown>
          <ActionDropdown
            isCanEdit={!original.isVerified}
            isCanRemove={!original.isVerified}
            id={original._id}
          />
        </RevealDropdown>
      </RevealDropdownTrigger>
    ),
    meta: {
      headerProps: { style: { width: '7%' } },
      cellProps: { className: 'text-end' }
    }
  }
];

const StudentsTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
      <AdvanceTableFooter serverSidePagination />
    </div>
  );
};

export default StudentsTable;
